/**
 * Inline SVG for the brand's double "o" as eyes with a smile.
 * Circles are filled white (#FFF) with dark stroke to match text color.
 */
export const EyesAndSmile = () => {
  return (
    <svg
      viewBox="00 00 76 52"
      width="1.35em"
      height="1em"
      className="mx-0.5 inline-block align-[-0.36em]"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <style>{`.stroke{stroke:#171717;}`}</style>
      </defs>
      {/* Eyes. */}
      <circle cx="19" cy="18" r="16" fill="#FFFFFF" className="stroke" strokeWidth="3" />
      <circle cx="57" cy="18" r="16" fill="#FFFFFF" className="stroke" strokeWidth="3" />
      {/* Pupils. */}
      <circle cx="26" cy="12" r="3" fill="#171717" />
      <circle cx="62" cy="12" r="3" fill="#171717" />
      {/* Smile. */}
      <path
        d="M2 38 C 28 50, 44 50, 74 38"
        fill="none"
        className="stroke"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AppTitle = ({ className }: { className?: string }) => {
  return (
    <div className={`${className} flex w-full justify-center text-4xl`}>
      <h1
        className="text-foreground-primary whitespace-nowrap leading-tight"
        style={{
          letterSpacing: '0.5px',
        }}
      >
        <span>patch</span>
        <EyesAndSmile />
        <span>li</span>
      </h1>
    </div>
  );
};
